"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const schema = {
    schemaType: "object",
    properties: [
        {
            title: "権限",
            propertyName: "role",
            schema: {
                schemaType: "selector",
                options: [
                    {
                        title: "権限なし",
                        value: null,
                    },
                    {
                        title: "プロジェクト管理者",
                        value: "master",
                    },
                    {
                        title: "プロジェクトユーザ",
                        value: "user",
                    },
                ],
            },
        },
        {
            title: "氏名",
            propertyName: "name",
            schema: { schemaType: "text" },
        },
        {
            title: "プロジェクト",
            propertyName: "projectIds",
            schema: {
                schemaType: "multipleExternalKey",
                uiType: "normal",
                resourcePath: "/project",
                titleKey: "projectName",
            },
        },
        {
            title: "所属",
            propertyName: "organization",
            schema: { schemaType: "text" },
        },
    ],
};
exports.default = schema;
